import { ToastContainer } from "react-toastify";
import { styled } from "@material-ui/core/styles";
import { HEADER_HEIGHT, TOAST_AUTO_CLOSE } from "../constants";

export const toastConfig = {
  autoClose: TOAST_AUTO_CLOSE,
};

const StyledToastContainer = styled(ToastContainer)({
  "&.Toastify__toast-container--top-right": {
    top: `calc(${HEADER_HEIGHT}px + 1em)`, // 1em is the margin-right of the toast container
  },
});

export default StyledToastContainer;
